module.exports = __webpack_public_path__ + "static/media/wallet.8c94cfbd.png";